<template lang="pug">
.social-links
  a(
    v-for="(link, $index) in links"
    :key="$index"
    :href="link.val"
    target="_blank"
  )
    b-icon(:icon="link.key")
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'social-links',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
    }),
    links() {
      const res = [];
      _.keys(this.value).forEach((key) => {
        if (this.value[key]) {
          res.push({
            key,
            val: this.value[key],
          });
        }
      });
      if (this.email && this.account.email) {
        res.push({ key: 'email-outline', val: `mailto:${this.account.email}` });
      }
      if (this.phone && this.account.phone_number) {
        res.push({ key: 'cellphone', val: `tel:${this.account.phone_number}` });
      }
      return res;
    },
  },
  props: {
    email: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.social-links {
  a {
    background-color: $grey-darker;
    color: $white !important;
    text-align: center;
    //padding: 0.3rem 0.4rem 0.25rem 0.4rem;
    width: 42px;
    height: 42px;
    border-radius: 100px;
    display: inline-block;
    transition: 0.35s background-color ease-in-out, 0.35s color ease-in-out;
    & + a {
      margin-left: 0.75rem;
    }
    &:hover {
      background-color: $primary !important;
    }
    .icon {
      position: relative;
      top: 8px;
    }
  }
}
</style>
